<template>
  <ArtboardFrame>
    <h1 class="heading">{{ t.errorHeading }}</h1>

    <p class="body">
      <span v-for="line in t.errorBody" :key="line" class="body__line">{{ line }}</span>
    </p>

    <CtaButton :label="t.errorCta" @click="onRetryClicked"/>

    <p v-if="reason" class="reason">{{ reason }}</p>

    <PageFooter/>
  </ArtboardFrame>
</template>

<script>
import {mapGetters} from "vuex";
import ArtboardFrame from "@/components/ArtboardFrame.vue";
import CtaButton from "@/components/CtaButton.vue";
import PageFooter from "@/components/PageFooter.vue";
import {triggerGTMEvent} from "@/functions/addGTM";

export default {
  name: 'ErrorPage',
  components: {ArtboardFrame, CtaButton, PageFooter},
  data() {
    return {
      reason: undefined
    }
  },
  computed: {
    ...mapGetters(['t'])
  },
  methods: {
    onRetryClicked() {
      triggerGTMEvent('error_retry_clicked');
      this.$router.push({name: 'Landing'});
    }
  },
  mounted() {
    this.reason = new URLSearchParams(window.location.search).get('reason') || undefined;
    triggerGTMEvent('error_page_view', {error_reason: this.reason || 'unknown'});
  }
}
</script>

<style scoped>
.heading {
  position: absolute;
  top: calc(330.1 * var(--u));
  left: 0;
  right: 0;
  margin: 0;
  font-size: calc(20 * var(--u));
  line-height: 1;
  font-weight: 700;
  text-align: center;
  color: var(--slate);
}

.body {
  position: absolute;
  top: calc(368.6 * var(--u));
  left: 0;
  right: 0;
  margin: 0;
  font-size: calc(11.9 * var(--u));
  line-height: calc(18 * var(--u));
  font-weight: 600;
  text-align: center;
  color: var(--body-grey);
}

.body__line {
  display: block;
}

.reason {
  position: absolute;
  top: calc(716 * var(--u));
  left: 0;
  right: 0;
  margin: 0;
  font-size: calc(9 * var(--u));
  line-height: 1;
  text-align: center;
  color: rgba(77, 89, 101, 0.5);
}
</style>
